
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import ArticleComponent from "./ArticleComponent.vue";
import { ArticleDto } from "@/dtos/articleDto";

@Component({
	components: {
		ArticleComponent,
	},
})
export default class AssemblyView extends Vue {
	@Prop()
	private assemblyArticleId!: number;

	private mounted() {
		this.loadSubarticles();
		// Prevent the articles from being reloaded when returning to the article dashboard.
		this.$store.commit("setReloadArticles", false);
	}

	private get assemblyArticle(): ArticleDto {
		return this.$store.state.articles.find(
			(a: ArticleDto) => a.articleId == this.assemblyArticleId
		);
	}

	private get subarticles() {
		return this.$store.state.articles.filter((a: ArticleDto) =>
			this.assemblyArticle.subArticleIds.includes(a.articleId)
		);
	}

	private async loadSubarticles() {
		try {
			const response = await httpClient().post(
				`Article/GetArticlesByIds`,
				this.assemblyArticle.subArticleIds
			);
			this.$store.commit("addOrUpdateArticles", response.data);
		} catch (ex) {
			console.error(ex);
		}
	}

	private removeArticle(articleId: any) {
		// Artikel wurde bereits im Backend gelöscht.
		// Falls vorhanden wird er lokal auch entfernt.
		this.$store.commit("removeArticle", articleId);
	}
}
